import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SingleSelect from "../../../../component/singleSelect/SingleSelect";
import Pagination from "../../../../component/pagination/Pagination";
import JobMapList from "../JobMapList";
import OptionThreeJobViewPage from "../OptionThree/OptionThreeJobViewPage";
import OptionFiveNoJob from "./OptionFiveNoJob";
import locationIcon from "../../../../assets/images/locationicon.svg";
import DataIcon from "../../../../assets/images/date-icon.svg";
import Image from "../../../../component/image/Image";
import "./option-five.scss";

const OptionFiveJobListing = (props: any) => {
    const {
        location,
        checkListControl,
        jobsList,
        setListView,
        listView,
        setTableControl,
        tableControl,
        sortList,
        pageSizeChange,
        displayPage,
        filterView,
        moveToJobViewPage,
        publishingDate,
        pageChange,
        filterListData,
        searchControlSubmit,
        navigateToJob,
        isMapViewEnabled,
        getListOfJob,
    } = props;

    const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
    const langLabels = clientConfig?.data?.data?.clientSettings?.languageSettings;
    const language = clientConfig?.data?.data?.clientSettings?.language;
    const showJobApplyButton = clientConfig?.data?.data?.clientSettings?.showJobApplyButtonInListing;
    const jobListingLangLabels = langLabels?.jobListing?.[0];
    const { t } = useTranslation();
    const navigate = useNavigate();

    const selectedSortList = {
        value: tableControl?.sort?.value,
        label: t(tableControl?.sort?.label)
    };

    const selectedPageSize = {
        value: tableControl?.pageSize?.value,
        label: tableControl?.pageSize?.value + " " + t(" per page")
    };

    const langSortList = sortList.map((item: any) => ({
        value: item.value,
        label: t(item.label)
    }));

    const langPageSize = displayPage.map((item: { value: string }) => ({
        value: item.value,
        label: item.value + " " + t(" per page")
    }));

    const navigateToJobAlerts = () => {
        navigate("/job-alerts");
    };

    const navigateToApplyJob = (jobId: string) => {
        navigate(`/view/${jobId}/apply-job/from/direct`);
    };

    if (location.pathname !== "/") {
        return (
            <OptionThreeJobViewPage
                jobDataView={filterView()}
                filterListData={filterListData}
                tableControl={tableControl}
                setTableControl={setTableControl}
                searchControlSubmit={searchControlSubmit}
                clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                navigateToJob={navigateToJob}
                getListOfJob={getListOfJob}
            />
        );
    }

    return (
        <div className="option5-jobs">
            <div className="option5-shell">
                <div className="option5-top">
                    {filterView()}
                </div>

                <div className="option5-toolbar">
                    <div className="option5-count">
                        <span className="option5-count-label">
                            {checkListControl ? t("Search Results") : jobListingLangLabels?.showingAll}
                        </span>
                        <strong>{jobsList?.data?.data?.jobs?.totalRecord || 0}</strong>
                    </div>

                    <div className="option5-controls">
                        <div className="option5-toggle" style={{ display: isMapViewEnabled === 0 ? "none" : "" }}>
                            <button className={listView === "list" ? "active" : ""} onClick={() => setListView("list")}>{jobListingLangLabels?.listView}</button>
                            <button className={listView === "map" ? "active" : ""} onClick={() => setListView("map")}>{jobListingLangLabels?.mapView}</button>
                        </div>

                        <div className="option5-select-wrap">
                            <SingleSelect
                                className="sort-control"
                                placeholder=""
                                onChange={(e: any) => {
                                    setTableControl((prs: any) => ({
                                        ...prs,
                                        sort: e
                                    }));
                                }}
                                value={selectedSortList}
                                options={langSortList}
                                isSearchable={false}
                            />
                        </div>

                        <div className="option5-select-wrap">
                            <SingleSelect
                                className="sort-control"
                                placeholder=""
                                onChange={(e: any) => pageSizeChange(e)}
                                value={selectedPageSize}
                                options={langPageSize}
                                isSearchable={false}
                            />
                        </div>
                    </div>
                </div>

                {tableControl.data.length > 0 ? (
                    <>
                        {listView === "list" ? (
                            <>
                                <div className="option5-grid">
                                    {tableControl.data.map((job: any) => (
                                        <article key={job.id} className="option5-card">
                                            <div className="option5-card-head">
                                                <h3 role="button" onClick={() => moveToJobViewPage(job)}>{job.title}</h3>
                                                <img
                                                    src={job.logo ? job.logo : "https://stag-compliance-careers.s3.ap-southeast-2.amazonaws.com/career-doc-settings/uploads/no_image.png"}
                                                    className="option5-logo"
                                                    alt="logo"
                                                />
                                            </div>

                                            <div className="option5-meta">
                                                {job.location?.location !== "" ? (
                                                    <span className="option5-chip">
                                                        <Image src={locationIcon} />
                                                        <small>{jobListingLangLabels?.location || "Location"}:</small>
                                                        {job.location?.location}
                                                    </span>
                                                ) : (
                                                    ""
                                                )}
                                                {job.postedAt !== "" ? (
                                                    <span className="option5-chip">
                                                        <Image src={DataIcon} />
                                                        <small>{jobListingLangLabels?.posted || "Posted"}:</small>
                                                        {publishingDate(job.postedAt, language)}
                                                    </span>
                                                ) : (
                                                    ""
                                                )}
                                            </div>

                                            <div className="option5-desc" dangerouslySetInnerHTML={{ __html: job.description }} />

                                            <div className="option5-actions">
                                                <button className="option5-btn option5-btn-ghost" onClick={() => moveToJobViewPage(job)}>
                                                    {t("Learn More")}
                                                </button>
                                                {showJobApplyButton === 1 ? (
                                                    <button className="option5-btn option5-btn-primary" onClick={() => navigateToApplyJob(job.id)}>
                                                        {t("Apply Now")}
                                                    </button>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </article>
                                    ))}
                                </div>

                                <div className="option5-pagination">
                                    <Pagination
                                        className="pagination-bar"
                                        currentPage={tableControl.currentPage}
                                        totalCount={tableControl.totalCount}
                                        pageSize={tableControl.pageSize?.value}
                                        onPageChange={(page: any) => pageChange(page)}
                                    />
                                </div>
                            </>
                        ) : (
                            <JobMapList jobList={tableControl.data} />
                        )}
                    </>
                ) : (
                    <OptionFiveNoJob navigateToJob={navigateToJob} navigateToJobAlerts={navigateToJobAlerts} />
                )}
            </div>
        </div>
    );
};

export default OptionFiveJobListing;
